"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "pdfWorkerFactory", {
  enumerable: true,
  get: function get() {
    return _pdfWorkerFactory["default"];
  }
});
var _pdfWorkerFactory = _interopRequireDefault(require("./pdf-worker-factory"));